export const hempRoutePermission = [
  {
    "title": "Dashboard",
    "redirectUrl": "/dashboard",
    "permissions": [
      {
        "title": "View all charts and data points",
        "status": true
      },
      {
        "title": "View Revenue related charts",
        "status": true
      },
      {
        "title": "View Orders related charts",
        "status": true
      },
      {
        "title": "View Products related charts",
        "status": true
      },
    ]
  },
  {
    "title": "POS",
    "redirectUrl": "/stores",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Product",
    "redirectUrl": "/products",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Inventory",
    "redirectUrl": "/inventories",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Orders",
    "redirectUrl": "/orders?orderFilter=&dateFilter=",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Members",
    "redirectUrl": "/members",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Manage Website",
    "redirectUrl": "/categories",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Promotions",
    "redirectUrl": "/promotions",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Settings",
    "redirectUrl": "/manages/roles-permissions",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  }
]
export const stiloRoutePermission = [
  {
    "title": "Dashboard",
    "redirectUrl": "/dashboard",
    "permissions": [
      {
        "title": "View all charts and data points",
        "status": true
      },
      {
        "title": "View Revenue related charts",
        "status": true
      },
      {
        "title": "View Orders related charts",
        "status": true
      },
      {
        "title": "View Products related charts",
        "status": true
      },]
  },
  {
    "title": "POS",
    "redirectUrl": "/stores",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Product",
    "redirectUrl": "/products",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Inventory",
    "redirectUrl": "/inventories",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Orders",
    "redirectUrl": "/orders?orderFilter=&dateFilter=",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Members",
    "redirectUrl": "/members",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Manage Website",
    "redirectUrl": "/categories",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Promotions",
    "redirectUrl": "/promotions",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Settings",
    "redirectUrl": "/manages/roles-permissions",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  }
]
export const HwRoutePermission = [
    {
        "title": "Manage Website",
        "redirectUrl": "/manage-cannabinoids",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "POS",
        "redirectUrl": "/stores",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "Product",
        "redirectUrl": "/hyperwolf/products",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "Employees",
        "redirectUrl": "/hyperwolf/manage-employess",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },

    {
        "title": "Members",
        "redirectUrl": "/hyperwolf/members",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "Orders",
        "redirectUrl": "/hyperwolf/orders",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "Drivers/Breaks",
        "redirectUrl": "/hyperwolf/driver",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
      "title": "Promotions",
      "redirectUrl": "/promotions",
      "permissions": [
        {
          "title": "Create",
          "status": true
        },
        {
          "title": "Edit/Update",
          "status": true
        },
        {
          "title": "Delete",
          "status": true
        },
        {
          "title": "View Only",
          "status": true
        }
      ]
    },
    {
        "title": "Settings",
        "redirectUrl": "/manages/roles-permissions",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
       {
        "title": "Inventory Distribution",
        "redirectUrl": "/hyperwolf/boxes",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
       {
        "title": "Loss Prevention",
        "redirectUrl": "/hyperwolf/closure-forms",
        "permissions": [
            {
                "title": "Create",
                "status": true
            },
            {
                "title": "Edit/Update",
                "status": true
            },
            {
                "title": "Delete",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    }
]
export const HperdriveRoutePermission = [

    {
        "title": "Map/Table",
        "redirectUrl": `/${process.env.REACT_APP_MODE}/hyperdrive/home?roleTab=map`,
        "permissions": [
            {
                "title": "Disable download CSV option",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "Analyze",
        "redirectUrl": `/${process.env.REACT_APP_MODE}/hyperdrive/home?roleTab=analyze`,
        "permissions": [
            {
                "title": "Disable download CSV option",
                "status": true
            },
            {
                "title": "View Only",
                "status": true
            }
        ]
    },

    {
        "title": "Route Analytics",
        "redirectUrl": `/${process.env.REACT_APP_MODE}/hyperdrive/home?roleTab=route_analytics`,
        "permissions": [
            {
                "title": "Disable download CSV option",
                "status": true
            }
            ,
            {
                "title": "View Only",
                "status": true
            }
        ]
    },
    {
        "title": "Driver Analytics",
        "redirectUrl": `/${process.env.REACT_APP_MODE}/hyperdrive/home?roleTab=driver_analytics`,
        "permissions": [
            {
                "title": "Disable download CSV option",
                "status": true
            }
            ,
            {
                "title": "View Details",
                "status": true
            }
        ]
    },
    {
        "title": "Create Task",
        "redirectUrl": "/manage-cannabinoids",
        "permissions": [
            {
                "title": "Start Task",
                "status": true
            },
            {
                "title": "Break task",
                "status": true
            },
            {
                "title": "Return To HQ",
                "status": true
            },

    ]
  },
  {
    "title": "Settings",
    "redirectUrl": "/manage-cannabinoids",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  }
]

export const posRoutePermission = [

  {
    "title": "Dashboard",
    "redirectUrl": "/dashboard",
    "permissions": [
      {
        "title": "View all charts and data points",
        "status": true
      },
      {
        "title": "View Revenue related charts",
        "status": true
      },
      {
        "title": "View Orders related charts",
        "status": true
      },
      {
        "title": "View Products related charts",
        "status": true
      },
    ]
  },

  {
    "title": "Products",
    "redirectUrl": "/products",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Master Catalog",
    "redirectUrl": "/master-catalog",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Orders",
    "redirectUrl": "/ecom-orders",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Members",
    "redirectUrl": "/members",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "Settings",
    "redirectUrl": "/storeinfo",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  },
  {
    "title": "POS/Fulfillment",
    "redirectUrl": "/pos",
    "permissions": [
      {
        "title": "Create",
        "status": true
      },
      {
        "title": "Edit/Update",
        "status": true
      },
      {
        "title": "Delete",
        "status": true
      },
      {
        "title": "View Only",
        "status": true
      }
    ]
  }
]